<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()
</script>

<template>
    <section class="pb-70 sm:pb-70 bg-[#EDFAF2] relative overflow-x-clip">
        <NuxtImg src="/images/home-page/home-our-story-pin-1.svg" alt="Pin" class="w-[150px] lg:w-[318px] absolute top-0 -left-[60px] lg:left-0" />
        <NuxtImg src="/images/home-page/home-our-story-map.svg" alt="Map" class="hidden xl:block lg:w-[134px] absolute top-0 lg:right-0" />
        <NuxtImg src="/images/home-page/home-our-story-pin-2.svg" alt="Pin" class="w-[50px] lg:w-[95px] absolute top-70 xl:top-120 -right-[15px] lg:right-16" />
        <NuxtImg src="/images/home-page/home-our-story-top-bg.svg" alt="Top background" class="w-full h-auto" />
        <UContainer class="flex flex-col pt-12 sm:pt-24">
            <div class="flex flex-col gap-4.5 items-center lg:max-w-[800px] mx-auto">
                <h2 class="uppercase text-center text-[#148744] text-[30px] leading-[38px] sm:text-[36px] sm:leading-[46px]">{{ t("home.ourStory.title") }}</h2>
                <p class="text-center text-[#032E14]">{{ t("home.ourStory.description") }}</p>
                <UButton color="primary" variant="outline" :to="localePath('moja-zgodba')" class="w-fit mx-auto mt-6">{{ t("home.ourStory.button") }}</UButton>
            </div>
        </UContainer>
    </section>
</template>

<style scoped>

</style>
